import { useState } from 'react';

import LedgerFinal from './LedgerFinal'
export default function FinalledgerPage() {
	
	const [pageReady, setPageReady] = useState(true);
	return (
		<main id="FinalledgerPage" className="main-page">
<section className="page-section q-pa-md" >
    <div className="container-fluid">
        <div className="grid ">
            <div className="col-12 comp-grid" >
                <div className="">
                    <div><LedgerFinal/></div>
                </div>
            </div>
        </div>
    </div>
</section>
		</main>
	);
}
